import { useState, useEffect } from "react"
import { projectAuth, projectStorage, projectFirestore } from "../firebase/config"
import {useAuthContext} from './useAuthContext'

export const useSignup = () =>{
    const [error, setError] = useState(null)
    const [isCancelled, setIsCancelled] = useState(false)
    const [isPending, setIsPending] = useState(null)
    const { dispatch} = useAuthContext()


    const signup = async (email, password, displayName, thumbnail) => {
        setError(null)
        setIsPending(true)

        try {
            // signup user

            const res = await projectAuth.createUserWithEmailAndPassword(email, password)
        

            if(!res){
                throw new Error("Could not complete signup")
            }

            // upload user thumbnail

            const uploadPath = `thumbnails/${res.user.uid}/${thumbnail.name}`

            const img = await projectStorage.ref(uploadPath).put(thumbnail)

            const imgURL = await img.ref.getDownloadURL()

            // add display name to user

            await res.user.updateProfile({displayName, photoURL: imgURL})

            // create a user document

            await projectFirestore.collection('users').doc(res.user.uid).set({
                online: true,
                displayName,
                photoURL: imgURL
            })

            // dispatch login action

            dispatch({type: 'LOGIN', payload: res.user})

            if (!isCancelled){
                setIsPending(false)
                setError(null)
            }

        } catch(err){
            if (!isCancelled){
                setIsPending(false)
                console.log(err.message)
                setError(err.message)
            }
        }
    }

    useEffect(() => {
        return () => setIsCancelled(true)
      }, [])

    return {signup, error, isPending}
}